import isModelForEditor from './isModelForEditor';
const getGlobalEditorContent = editorName => {
  var _matchingModel$getVal;
  if (window.monaco == null) {
    return null;
  }
  const models = window.monaco.editor.getModels();
  const matchingModel = models.find(model => isModelForEditor(model, editorName));
  return (_matchingModel$getVal = matchingModel === null || matchingModel === void 0 ? void 0 : matchingModel.getValue()) !== null && _matchingModel$getVal !== void 0 ? _matchingModel$getVal : null;
};
export default getGlobalEditorContent;